/**
 * `shopify-get_order_status` → `Get Order Status` — a tool id as the editor names it.
 *
 * One implementation because the workflow summary and the step inspector title the same
 * tool, and two private copies is how they eventually title it differently.
 */
export function humanizeToolName(tool: string): string {
  return tool
    .replace(/^[a-z0-9]+[-:]{1,2}/i, "") // a provider prefix the model sometimes bakes in
    .replace(/[_-]+/g, " ")
    .trim()
    .replace(/\b\w/g, (character) => character.toUpperCase());
}
